"use strict";

var baseSortBy = require("../.internal/baseSortBy.js");

var curry = require("./curry.js");

module.exports = curry(function sortByDesc(f, arr) {
  return baseSortBy(1, -1, f, arr);
});